document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.main-policy').forEach((section) => {
    const links = Array.from(section.querySelectorAll('.main-policy__toc-link'));
    if (!links.length) return;

    const pairs = links
      .map((link) => {
        const id = decodeURIComponent((link.getAttribute('href') || '').replace('#', ''));
        const target = id && document.getElementById(id);
        return target ? { link, target } : null;
      })
      .filter(Boolean);

    if (!pairs.length) return;

    const setActive = (activeLink) => {
      links.forEach((link) => {
        link.classList.toggle('main-policy__toc-link--active', link === activeLink);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const pair = pairs.find((item) => item.target === entry.target);
          if (pair) setActive(pair.link);
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    pairs.forEach(({ target }) => observer.observe(target));
  });
});
